import gCard from "../g-card/g-card.vue";
import gMenuItem from "@/components/g-menu/components/g-menu-item.vue";
import router from "@/router";


const name = 'g-navbar'
export default {
  name,

  components: {
    'g-card': gCard,
    'g-menu-item': gMenuItem
   },

  props: {


   },

  mounted () {

    let naoTemMenu = ['ajuda'].includes(this.$route.path.replace('/',''))
    return naoTemMenu ? 'none':'block'
  },

  updated () { },

  data () {
    return {
        itensMenu: [
            {
              rota: "dashboard",
              titulo: "Minha Área",
              subItens: [],
            },
            {
              rota: "pasta_produtos-cliente_produtos-estoque_vendas-por-periodo_pedidos-por-nota-fiscal_notas-fiscais_pedidos-por-titulos_titulos_comissoes_devolucoes",
              titulo: "Consultas",
              subItens: [
                {
                    rota:"produtos-cliente",
                    titulo: "Produtos por Cliente",
                    subItens:[]
                },
                {
                    rota:"produtos-estoque",
                    titulo: "Produtos em Estoque",
                    subItens: [],
                },
                {
                  rota:"vendas-por-periodo",
                  titulo: "Vendas por Período",
                  subItens:[]
                },
                {
                  rota:"notas-fiscais",
                  titulo: "Notas Fiscais",
                  subItens: [],
                },
                {
                  rota:"titulos",
                  titulo: "Títulos",
                  subItens: [],
                },
                {
                  rota:"comissoes",
                  titulo: "Comissões",
                  subItens: [],
                },
                {
                  rota:"devolucoes",
                  titulo: "Devoluções",
                  subItens: [],
                },

              ],
            },
            {
              rota: "pasta_formularios_reclamacao-tecnica-comercial_checklist-amostra-lote",
              titulo: "Formulários",
              subItens: [
                {
                  rota:"reclamacao-tecnica-comercial",
                  titulo: "Reclamação Técnica/Comercial",
                  subItens:[],
                },
                {
                  rota:"checklist-amostra-lote",
                  titulo: "Checklist Amostra/Lote",
                  subItens:[],
                }
              ],
            },
            {
              rota: "pasta_cliente_cliente-em-desenvolvimento_ficha-cadastro_cliente-consulta",
              titulo: "Clientes",
              subItens: [

              {
                rota:"cliente-consulta",
                titulo: "Cliente Consulta",
                subItens:[],
              },
              {
                rota: "cliente-em-desenvolvimento",
                titulo: "Em Desenvolvimento",
                subItens: [],
              },
              {
                rota:"ficha-cadastro",
                titulo: "Ficha Cadastral",
                subItens:[],
              }
              ],
            },
            {
              rota: "pasta_consultar-orcamento_produto-novo-inicio_orcamentos-pendentes_orcamentos-liberados_orcamento-em-digitacao_produto-repeticao-inicio_produto-repeticao-alteracao-inicio",
              titulo: "Orçamentos",
              subItens: [
                {
                  rota:"consultar-orcamento",
                  titulo: "Consultar Orçamento",
                  subItens:[]
                },
                {
                  rota:"orcamento-em-digitacao",
                  titulo: "Em Digitação",
                },
                {
                  rota:"orcamentos-pendentes",
                  titulo: "Pendentes de Retorno",
                  subItens:[]
                },
                {
                  rota:"orcamentos-liberados",
                  titulo: "Liberados",
                },
                {
                    rota:"produto-novo-inicio",
                    titulo: "Produto Novo",
                    subItens: [],
                },
                {
                  rota:"produto-repeticao-inicio",
                  titulo: "Produto Repeticao",
                  subItens: [],
                },
                {
                  rota:"produto-repeticao-alteracao-inicio",
                  titulo: "Produto Repetição c/ Alteração",
                  subItens: [],
                },
            ],
            },
            {
              rota: "pasta_carta-proposta_carta-proposta-em-digitacao_cartas-proposta-aguardando-aprovacao_consultar-cartas-proposta_gerar-carta-proposta-inicio",
              titulo: "Cartas-Proposta",
              subItens: [
                {
                  rota: "consultar-cartas-proposta",
                  titulo: "Consultar Cartas-Proposta",
                  subItens: [],
                },
                {
                  rota: "carta-proposta-em-digitacao",
                  titulo: "Em Digitação",
                  subItens: [],
                },
                // {
                //   rota: "cartas-proposta-aguardando-aprovacao",
                //   titulo: "Aguardando Aprovação",
                //   subItens: [],
                // },
                {
                  rota:"gerar-carta-proposta-inicio",
                  titulo: "Gerar Carta Proposta",
                  subItens: [],
                },
              ],
            },
            {
              rota: "pasta_pedidos_pedido-em-digitacao_pedido-em-fase-digitacao_andamento-de-pedidos_pedido-cancelado-liquidado_pedido-expedido-faturado_gerar-novo-pedido-inicio",
              titulo: "Pedidos",
              subItens: [
                {
                  rota:"pedido-em-digitacao",
                  titulo: "Em Digitação",
                  subItens: [],
                },
                {
                  rota:"pedido-em-fase-digitacao",
                  titulo: "Em Fase De Digitação",
                  subItens: [],
                },
                {
                  rota:"andamento-de-pedidos",
                  titulo: "Andamento De Pedidos",
                  subItens: [],
                },
                {
                  rota:"pedido-cancelado-liquidado",
                  titulo: "Cancelados",
                  subItens: [],
                },
                {
                  rota:"pedido-expedido-faturado",
                  titulo: "Expedidos / Faturados",
                  subItens: [],
                },
                {
                  rota:"gerar-novo-pedido-inicio",
                  titulo: "Gerar Novo Pedido",
                  subItens: [],
                },
              ],
            },
        ]

     }
  },

  methods: {
    redirecionar(rota){
        router.push(`/${rota}`)
    },
    verificaSubItem(vetor){
        return vetor !== []
    },
    ativo(rota){
        return rota.includes(this.$route.path.replace('/','')) ? 'ativo' : ''
    }
  },

  computed: {
    display(){
        let naoTemMenu = ['/ajuda'].includes(this.$route.path.replace('/',''))
        return naoTemMenu ? 'none':'block'
    }
   },

};